var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stretch-vertical home"},[_c('div',{staticClass:"text-content-section stretch-vertical",domProps:{"innerHTML":_vm._s(_vm.pageContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }